import { getHoverColor } from "@/utils/colorUtils"
import { accordionAnatomy as parts } from "@chakra-ui/anatomy"
import {
  PartsStyleFunction,
  SystemStyleFunction,
  SystemStyleObject,
} from "@chakra-ui/theme-tools"
import { $color } from "@/utils/cssVarUtils"


const baseStyleRoot: SystemStyleObject = {
  mt: 0,
  fontSize: 'md',
  width: '100%',
}

const baseStyleContainer: SystemStyleObject = {
  borderTop: 'none',
  borderBottom: 'none',
}

const baseStyleButton: SystemStyleFunction = (props) => {
  const hoverColor = getHoverColor(props)

  return {
    borderBottom: '1px solid',
    borderColor: $color('scene-border'),
    px: 'md',
    py: 0,
    height: '7xl',
    _focus: {
      boxShadow: "none",
    },
    _hover: {
      bg: hoverColor,
    },
  }
}

const baseStylePanel: SystemStyleObject = {
  fontSize: 'xs',
  p: 'md',
}

const baseStyleIcon: SystemStyleObject = {
  fontSize: 'xl',
}

const baseStyle: PartsStyleFunction<typeof parts> = (props) => {
  return {
    root: baseStyleRoot,
    container: baseStyleContainer,
    button: baseStyleButton(props),
    panel: baseStylePanel,
    icon: baseStyleIcon,
  }
}

export const Accordion = {
  parts: parts.keys,
  baseStyle,
}